import React from "react";
import { ReactComponent as PluginSvg } from "@assets/icons/collapse_settings.svg";
import { createCard } from "@whalecloud/page-builder-core/utils/elementUtils";
import CollapseElement from "./components/CollapseElement";
import CollapseSetting from "./components/CollapseSetting";
import { getLocale } from '@utils/util';

const createChildren = () => {
  return [createCard()];
}

export default () => {
  const messages = getLocale();
  return {
    name: 'collapse', // 插件名，不能包含空格,空格用-代替
    title: messages['PAGEBUIDER_ELEMENT_COLLAPSE'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: { // 插件初始化数据
      settings: {
        width: {
          value: "100%"
        },
      }, // 插件样式属性
      formItemSettings: {
        bordered: true,
        expandIconPosition: 'left',
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_COLLAPSE'],
      },
    },
    elements: createChildren,
    pluginComponent: CollapseElement, // 插件组件
    pluginSettingComponent: CollapseSetting, // 插件设置项组件
  }
}
